


















































































import { swiper as Swiper, swiperSlide as SwiperSlide } from "vue-awesome-swiper"
import { CONTRACT_STATUS } from "../constant"
import { defineComponent, onMounted } from "@vue/composition-api"

// hooks
import useIndex from "./useIndex"
import useLocation from "./useLocation"
import useAppleAuth from "./useAppleAuth"
import useSwiper from "./useSwiper"

// components
import Loading from "./Common/Loading.vue"
import PopupBox from "./PopupBox.vue"
import Coupons from "./Coupons/index.vue"
import MaskId from "./MaskId/index.vue"
import Recharge from "./Recharge/index.vue"
import AppleAuth from "./AppleAuth/index.vue"
import GiftTask from "./GiftTask/index.vue"
import Toast from "../../../components/common/toast.vue"
import BannerText from "./BannerText/index.vue"
import GiftEnter from "./GiftEnter.vue"

export default defineComponent({
  name: "Index",
  components: {
    PopupBox,
    SwiperSlide,
    Swiper,
    Loading,
    Coupons,
    MaskId,
    Recharge,
    AppleAuth,
    GiftTask,
    Toast,
    BannerText,
    GiftEnter
  },
  setup() {
    const appleAuth = useAppleAuth()
    const index = useIndex({ showAppleAuth: appleAuth.showAppleAuth })
    const location = useLocation()
    const swiper = useSwiper()

    const { checkSignError, init } = index
    const checkSignRetry = () => {
      checkSignError.value = false
      appleAuth.showAppleAuth()
      // init(true)
    }

    onMounted(() => {
      void init(true)
    })

    return {
      ...index,
      ...appleAuth,
      ...location,
      ...swiper,
      CONTRACT_STATUS,
      checkSignRetry
    }
  }
})
